import { HiOutlineArrowLeft } from "react-icons/hi"
import "../styles/SinglePersonFromTree.css"
import { useNavigate } from "react-router"
import { useEffect } from "react"

const SinglePersonFromTree = () => {
    const navigate = useNavigate()
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return<>
        <div className="personalHistory">
            <HiOutlineArrowLeft onClick={() => navigate("/")}/>

            <div className="personalInformation">
                <img src="" alt="" />
                <div className="pinfoGroup">
                    <div className="firstGroup">
                        <div className="innerGroup">
                            
                            <p><small>Name</small> Newton Wayne Becker</p>
                        </div>
                        <div className="innerGroup">
                            <p><small>Relationship</small> Son</p>
                            <p><small>Position</small> First</p>
                        </div>
                    </div>
                    <div className="bioGroup">
                        <small>Bio</small>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque dignissim ac eros a lobortis. Nulla malesuada quam quis magna auctor, in porttitor orci rhoncus</p>
                    </div>
                </div>
            </div>

            <div className="galleryWrapper">
                <img src="" alt="" />
                <img src="" alt="" />
                <img src="" alt="" />
                <img src="" alt="" />
                <img src="" alt="" />
                <img src="" alt="" />
            </div>

        </div>

    </>

}

export default SinglePersonFromTree